import { Dispatch, SetStateAction, useEffect, useState } from 'react'

function getSavedValue<T>(key: string, initialState: T): T {
  const savedState: T = JSON.parse(localStorage.getItem(key) as string)
  if (savedState) return savedState

  if (initialState instanceof Function) return initialState()
  return initialState
}

export function useLocalStorage<T>(key: string, initialState: T): [T, Dispatch<SetStateAction<T>>] {
  const [state, setState] = useState<T>(() => {
    return getSavedValue<T>(key, initialState)
  })

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(state))
  }, [state])

  return [state, setState]
}
